import type { ComponentPropsWithoutRef, MouseEvent } from "react"
import { t } from "@lingui/core/macro"
import { useAppContext } from "../../../hooks/appContext"
import { Sizes } from "../../../interfaces/sizing"
import { mergeClasses } from "../../../utils/css"
import { Button, ButtonColor, ButtonSize, Flex, Typography } from "../../common"
import { CircleLockIcon } from "../../common/atoms/Icons/Others"
import { InfoIconTooltip } from "../../common/molecules/InfoIconTooltip"
import "./AgeGateTeaseOverlay.scss"

export function AgeGateTeaseOverlay({
    ...props
}: ComponentPropsWithoutRef<"div">) {
    const isMobile = useAppContext()?.context?.is_mobile
    const { age_gate_location } = useAppContext().context
    const ageGateLocation = age_gate_location

    const showAgeGateTeaseOverlay = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        if (typeof (window as any).showAgeGate === "function") {
            ;(window as any).showAgeGate()
        }
    }

    return (
        <div
            id="AGTOverlay"
            className={mergeClasses(
                "AgeGateTeaseOverlay",
                isMobile ? "AgeGateTeaseOverlay--mobile" : "",
            )}
            {...props}
        >
            <Flex
                direction="column"
                align="center"
                justify="center"
                className="AgeGateTeaseOverlay__content"
            >
                <CircleLockIcon className="AgeGateTeaseOverlay__icon" />
                <Typography
                    component={isMobile ? "h3" : "h2"}
                    size={isMobile ? Sizes.mdpx : Sizes.lg}
                    weight="bold"
                    className="AgeGateTeaseOverlay__title"
                >
                    {t`Verify Your Age`}
                </Typography>
                <Flex
                    direction="row"
                    align="center"
                    justify="center"
                    className="AgeGateTeaseOverlay__content__primary"
                >
                    <Typography
                        component="p"
                        size={isMobile ? Sizes.smpx : Sizes.sm}
                        className="AgeGateTeaseOverlay__content__primary__description"
                    >
                        {t`Visitors In ${ageGateLocation} must verify their age to access Chaturbate.`}
                    </Typography>
                    {!isMobile && (
                        <InfoIconTooltip
                            className="AgeGateTeaseOverlay__content__primary__tooltip"
                            strokedIcon={true}
                        >
                            <Typography
                                component="h2"
                                size={Sizes.smpx}
                                className="AgeGateTeaseOverlay__content__primary__tooltip-body-text"
                            >
                                {/* TODO(CBD-2647): Add legal text*/}
                                Text to be put in here.
                            </Typography>
                        </InfoIconTooltip>
                    )}
                </Flex>
                <Typography
                    component="p"
                    size={isMobile ? Sizes.smpx : Sizes.sm}
                    className="AgeGateTeaseOverlay__description"
                >
                    {t`This process will take less than one minute.`}
                </Typography>

                <Button
                    text={t`VERIFY AGE`}
                    size={isMobile ? ButtonSize.Small : ButtonSize.Large}
                    color={ButtonColor.Orange}
                    onClick={showAgeGateTeaseOverlay}
                    className="AgeGateTeaseOverlay__button"
                />
            </Flex>
        </div>
    )
}
